import React from 'react';
import { AppNavigate, AppOutlet } from '@/navigation';
import { ROUTES } from '@/routes';
import { isMPIEnabled } from '@/config';
import { useAppSelector } from '@/hooks';
import { selectMissingItemForm } from '@/store/slices';

export const MissingItemRoute: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const { userMissingItemForms } = useAppSelector(selectMissingItemForm);
  const hasMissingItems = userMissingItemForms.length > 0;

  return hasMissingItems && isMPIEnabled() ? (
    <>{children ?? <AppOutlet />}</>
  ) : (
    <AppNavigate to={ROUTES.dashboard} replace />
  );
};
